import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { publishLogout } from './authSync';
import { logoutCurrentSession } from './logout';
import { authStatusSelector, AUTH_STATUSES, logoutErrorSelector } from '../slices/authSlice';

export const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const status = useSelector(authStatusSelector);
  const error = useSelector(logoutErrorSelector);

  const logout = useCallback(async () => {
    const result = await dispatch(logoutCurrentSession());
    navigate('/', { replace: true });
    publishLogout();
    return result;
  }, [dispatch, navigate]);

  return {
    logout,
    error,
    isLoggingOut: status === AUTH_STATUSES.LOGGING_OUT,
    isLogoutRetryable: status === AUTH_STATUSES.LOGOUT_ERROR
  };
};
